import * as THREE from 'three';

export function createLights(scene: THREE.Scene) {

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);


  // Ambient light for general illumination (brighter)
  const ambientLight = new THREE.AmbientLight(0x2b1b3a, 1.0); // Increased intensity from 0.6 to 1.0
  scene.add(ambientLight);
  
  // Directional light (moonlight effect)
  const directionalLight = new THREE.DirectionalLight(0x8e7cc3, 5); // Increased intensity for balance
  directionalLight.position.set(5, 15, 7.5); // Higher position
  directionalLight.castShadow = false
  
  // Configure shadow properties
  if (!isMobile) {
    directionalLight.shadow.mapSize.width = 2048;
    directionalLight.shadow.mapSize.height = 2048;
    directionalLight.shadow.camera.near = 0.5;
    directionalLight.shadow.camera.far = 50;
    directionalLight.shadow.camera.left = -20;
    directionalLight.shadow.camera.right = 20;
    directionalLight.shadow.camera.top = 20;
    directionalLight.shadow.camera.bottom = -20;
  }
  
  scene.add(directionalLight);
  
  // Purple accent lights (adjusted intensity for new ambient level)
  const purpleLight1 = new THREE.PointLight(0x9932cc, 2.0, 15); // Reduced intensity to balance with higher ambient
  purpleLight1.position.set(-14.5, 7, -14.5); // Moved away from corners
  purpleLight1.castShadow = true;
  if (!isMobile) {
    scene.add(purpleLight1);
  }
  
  const purpleLight2 = new THREE.PointLight(0x9932cc, 2.0, 15);
  purpleLight2.position.set(14.5, 7, -14.5);
  purpleLight2.castShadow = true;
  if (!isMobile) {
    scene.add(purpleLight2);
  }
  
  // Blue accent lights for gaming areas (adjusted intensity)
  const blueLight1 = new THREE.PointLight(0x00bfff, 2.0, 12); // Reduced intensity to balance
  blueLight1.position.set(-14.5, 7, 14.5);
  blueLight1.castShadow = true;
  if (!isMobile) {
    scene.add(blueLight1);
  }
  
  const blueLight2 = new THREE.PointLight(0x00bfff, 2.0, 12);
  blueLight2.position.set(14.5, 7, 14.5);
  blueLight2.castShadow = true;
  if (!isMobile) {
    scene.add(blueLight2);
  }
  
  // Add spotlights for the grid ceiling lights (adjusted intensity)
  const spotlights: THREE.SpotLight[] = [];
  const gridSize = 5;
  const spacing = 4.8; // Match ceiling grid spacing
  const startX = -9.6; // Match ceiling grid start position
  const startZ = -9.6;

  for (let i = 0; i < gridSize; i++) {
    for (let j = 0; j < gridSize; j++) {
      const isAlternating = (i + j) % 2 === 0;
      const spotLight = new THREE.SpotLight(
        isAlternating ? 0x9932cc : 0xffffff,
        0.6, // Reduced spotlight intensity to balance with higher ambient
        15,
        Math.PI / 4,
        0.5,
        2
      );
      spotLight.position.set(
        startX + i * spacing,
        7.85, // Slightly below ceiling panels
        startZ + j * spacing
      );
      spotLight.target.position.set(
        startX + i * spacing,
        0,
        startZ + j * spacing
      );

      if (!isMobile) {
        scene.add(spotLight);
        scene.add(spotLight.target);
        spotlights.push(spotLight);
      }
    }
  }
} 